import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlaybookLogsQuery$variables } from './__generated__/PlaybookLogsQuery.graphql';
import PlaybookLogsQuery$parameters from './__generated__/PlaybookLogsQuery$parameters';

export const playbookLogsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-playbook-logs" */ './PlaybookLogs'),
	),
	getPreloadProps: (variables: PlaybookLogsQuery$variables) => ({
		queries: {
			PlaybookLogsQuery: {
				parameters: PlaybookLogsQuery$parameters,
				variables,
			},
		},
	}),
});
